module.exports = __webpack_public_path__ + "img/42_35_440_004.f2ae29bd.jpg";